<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="container-sm-table">
      <div class="listings-navbar">
        <el-row
          :gutter="20"
          type="flex"
          justify="end"
          class="inner-navbar-buttons-alignment"
        >
          <el-col :lg="7">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li v-if="hasPermission('cases', 'report_upload_new')">
                <el-button class="btn button-with-icon" @click="uploadFiles">
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span> UPLOAD REPORTS </span>
                </el-button>
              </li>
            </ul>
          </el-col>
          <el-col :lg="17">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Search Name"
                    v-model="searchString"
                    @input="searchBatches"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
          v-if="this.getReportFiles && this.getReportFiles.data"
        >
          <el-table
            :data="getReportFiles.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              prop="title"
              label="File Name"
              min-width="250"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession">
                  <router-link
                    :to="{
                      name: 'ViewTsiReoport',
                      params: { id: scope.row._id },
                      query: $route.query,
                    }"
                  >
                    {{ scope.row.title }}
                  </router-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Report Status" width="180">
              <template #default="scope">
                <div class="column-status">
                  <el-tag :type="getStatus(scope.row.status)">
                    {{ scope.row.status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Progress" width="250">
              <template #default="scope">
                <el-button
                  v-if="
                    (scope.row.status == 'ACTIVE' ||
                    scope.row.status == 'TO-START') &&
                    hasPermission('cases', 'report_upload_new')
                  "
                  @click="generateReport(scope.row)"
                  title="Generate Report"
                  class="generate-btn"
                >
                  Generate Report
                </el-button>
                <el-button
                  class="processing-btn"
                  @click="viewProgress(scope.row)"
                  v-else
                  >View Progress</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Created By"
              prop="created_by"
              width="250"
              sortable="custom"
            >
              <template v-slot="scope">
                {{
                  scope.row.created_by.first_name +
                  " " +
                  scope.row.created_by.last_name
                }}</template
              >
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              prop="created_at"
              width="150"
              sortable="custom"
            >
              <template v-slot="scope">
                {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="90">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      @click="archiveConfirm(scope.row)"
                      title="Delete"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="downloadReport(scope.row)"
                      title="Download"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="getReportFiles.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <div class="default-modal">
        <el-dialog
          v-model="askReportToDownload"
          width="25%"
          v-loading="loading"
        >
          <div class="dialog-header">
            <span class="header-part"> Select Report To Download </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="askReportToDownload = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>
          <el-row :gutter="20" type="flex" class="popup-date">
            <el-col :span="24">
              <div class="tsi-reports">
                <div class="date-type-checkbox">
                  <span class="checkbox-header">SELECT REPORT :</span>

                  <el-radio-group v-model="report" class="text-center">
                    <el-radio label="result_file" value="result_file"
                      >Result File</el-radio
                    >

                    <el-radio label="cnv_file" value="cnv_file"
                      >CNV File</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="dialog-footer justify-center">
                <el-button
                  class="cancel-button"
                  @click="askReportToDownload = false"
                  >CANCEL</el-button
                >
                <el-button class="blue-save-button" @click="downloadReports"
                  >DOWNLOAD</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      page: 1,
      pageSize: 25,
      loading: false,
      searchString: "",
      filterCaseType: "",
      orderBy: "",
      orderType: "",
      allowedPanels: ["CARDIAC", "PULMONARY_PANEL"],

      askReportToDownload: false,
      report: "",
      selectedReport: {},
      refreshPageSeconds: 2000,
      refresh: false,
      searchBy: "",
      searchOptions: [
        {
          value: "FileName",
          label: "File Name",
        },
      ],
      searchByKey: ["FileName"],
    };
  },
  computed: {
    ...mapGetters("tsiReports", [
      "getReportFiles",
      "getReportDeleteStatus",
      "getDownloadUrl",
      "getPatientDemographicSentStatus",
      "getSendFileToServerStatus",
      "getFileDownloadStatus",
      "getSyncReportStatus",
      "getGenerateReportStatus",
    ]),
    ...mapGetters("profile", ["getTestPanelsData"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    isSearchByInput() {
      return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    },
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [25, 50, 75, 100],
      };
    },
    getAllowedPanels() {
      return this.getTestPanelsData.filter(
        (e) => this.allowedPanels.indexOf(e.code) > -1
      );
    },
    getStatus() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "PROCESSING") {
          return "default";
        } else if (status == "COMPLETED") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TO-START") {
          return "info";
        } else if (status == "FAILED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  mixins: [UserPermissionsHelper, FilterHelper],
  async mounted() {
    this.setQueryParams();
    await this.getReports(this.page);
  },

  methods: {
    viewProgress(report) {
      this.$router.push({
        name: "ViewTsiReoport",
        params: { id: report._id },
      });
    },
    async generateReport(result) {
      try {
        this.loading = true;
        let result_file_id = result._id;
        await this.$store.dispatch(
          "tsiReports/generaTSIteReport",
          result_file_id
        );
        if (this.getGenerateReportStatus) {
          successNotification("Report Generated Successfuly");
          this.report = "";
          this.getReports(this.page);
        } else if (!this.getErrors || this.getError) {
          errorNotification(this.getError);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.getReports();
    },
    setQueryParams() {
      this.searchString = this.$route.query.selectedTsiString;
      this.page = this.$route.query.selectedTsiPage
        ? parseInt(this.$route.query.selectedTsiPage)
        : 1;
      this.pageSize = this.$route.query.selectedTsiPageSize
        ? parseInt(this.$route.query.selectedTsiPageSize)
        : 25;
      this.searchBy = this.$route.query.selectedSearchBy;
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
      if (this.$route.query.selectedOrder) {
        this.orderBy = this.$route.query.selectedOrder;
      }
    },
    clearInputSearch() {
      this.searchString = "";

      this.isSearchByInput = "";
      this.getReports(1);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.getReports(this.page);
    },
    handleCurrentChange(page) {
      this.page = page;

      this.getReports(this.page);
    },
    uploadFiles() {
      this.$router.push({ path: "/pgx-reports/upload-pgx-report" });
    },
    async getReports(page, applyQuery = true) {
      this.loading = true;
      this.page = page;
      let params = this.prepareParams();
      await this.$store.dispatch("tsiReports/fetchAll", params);
      if (applyQuery) {
        this.updateQueryParams(params);
      } else {
        this.updateQueryParam(this.$route.name, {}, true);
      }
      this.loading = false;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedTsiPage: params.page,
        selectedOrder: params.order_by,
        selectedOrderType: params.order_type,
        selectedTsiString: this.searchString,
        selectedTsiPageSize: params.limit,
        selectedSearchBy: this.searchBy,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    prepareParams() {
      let params = { page: this.page, limit: this.pageSize };
      if (this.filterCaseType) {
        params.case_type = this.filterCaseType;
      }
      if (this.searchString) {
        params.search_string = this.searchString;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    downloadReport(report) {
      this.selectedReport = report;
      this.askReportToDownload = true;
    },
    async downloadReports() {
      try {
        this.loading = true;
        await this.$store.dispatch("tsiReports/download", {
          report_id: this.selectedReport._id,
          report_type: this.report,
        });

        let url = this.getDownloadUrl;
        window.open(url, "_blank");
        if (this.getFileDownloadStatus) {
          this.askReportToDownload = false;

          successNotification("File Downloaded Successfully");
          this.report = "";
        } else if (!this.getErrors || this.getError) {
          errorNotification(this.getError);
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    archiveConfirm(data) {
      this.$confirm(`Are you sure want to DELETE ${data.title}?`, "Warning", {
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.archiveReportFile(data);
      });
    },
    async archiveReportFile(data) {
      this.loading = true;
      await this.$store.dispatch("tsiReports/delete", data._id);
      this.loading = false;
      if (this.getReportDeleteStatus) {
        successNotification("Reports List deleted successfully");
        await this.getReports(this.page);
      } else {
        errorNotification("Error in deleting Reports List");
      }
    },
    searchBatches() {
      setTimeout(() => {
        this.getReports(this.page);
      }, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin button-css {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    color: #4bb543;
    border: 0.6px solid #4bb543;
  }
}
.btn-success {
  @include button-css;
}

.btn-active {
  @include button-css;
  color: #5162fd;
  border: 0.6px solid #5162fd;
  &:hover,
  &:active {
    color: #5162fd;
    border: 0.6px solid #5162fd;
  }
  &.is-disabled {
    color: #5162fd;
    border: 0.6px solid #5162fd;
    opacity: 0.5;
    &:hover {
      color: #5162fd;
      border: 0.6px solid #5162fd;
      opacity: 0.5;
    }
  }
}
.btn-processing {
  @include button-css;
  color: #f28b0c;
  border: 0.6px solid #f28b0c;
  &:hover,
  &:active,
  &:focus {
    color: #f28b0c;
    border: 0.6px solid #f28b0c;
  }
}
.generate-btn {
  color: #273480;
  padding: 0 !important;
  border: none !important;
  border-radius: 5px;
  min-height: 30px;

  &:hover,
  &:focus,
  &:active {
    color: #273480;
    background-color: transparent;
    padding: 0 !important;
  }
}
.processing-btn {
  color: #f28b0c;
  padding: 0 !important;
  border: none !important;
  border-radius: 5px;
  min-height: 30px;

  &:hover,
  &:focus,
  &:active {
    color: #f28b0c;
    background-color: transparent;
    padding: 0 !important;
  }
}
</style>
<style lang="scss">
.tsi-reports {
  .date-type-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;

    .checkbox-header {
      color: #273480;
      font-weight: 600;
      font-size: 14px;
      padding: 10px;
    }
    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #273480;
      border-color: #ffffff;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #273480;
    }
  }
  .justify-center {
    justify-content: center !important;
  }
}
</style>
